import { GeaoPaths } from "../components/GeaoOnboarding/constants/GeaoPaths.js";
export class HttpStatusError extends Error {
    /**
     * Thrown when the HTTP response code is not 200.
     * @param {string} message The error message describing the issue.
     * @param {Response} response The fetch API response object.
     * @param {any} body The parsed response body, either as a JavaScript object or a string.
     */
    constructor(message, response, body) {
        super(message);
        this.name = "HttpStatusError";
        this.response = response;
        this.body = body;
    }
}

/**
 * Checks the response object for HTTP error codes and validations errors.
 * @param {Response} response The fetch API response object.
 * @returns {any} The HTTP response body as a JavaScript object if the body is JSON, otherwise the body content as a string.
 * @throws {Error} When there are validation errors.
 * @throws {HttpStatusError} When the HTTP status is not OK
 */
export async function handleErrors(response) {
    const bodyText = await response.text();

    const body = (() => {
        try {
            return JSON.parse(bodyText);
        }
        catch {
            return bodyText;
        }
    })();

    // Check for FluentValidations errors.
    if (body?.isValid === false && body.errors) {
        throw new Error(JSON.stringify(body.errors, null, 4), response);
    }

    // Check for HTTP error codes.
    if (!response.ok) {
        throw new HttpStatusError(response.statusText, response, body);
    }

    return body;
}

export function handleUnauthorized(response) {
    if (response.status === 401) {
        window.location.href = GeaoPaths.SessionExpired;
    }
    return response;
}
